import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—December 2005" />
	<Old2005BlogPage>
		<h2>December 2005</h2>







		<h3 className="blogdate">
		Saturday, December 31, 2005
		</h3>






		<h4 className="blogitemtitle">
		Go to Singapore!
		</h4>





			<div className="blogitembody">
			It's not difficult - Singapore has its own airline! How many island cities in this world are also a country? I didn't fly to Singapore, I took the KTM Ekspress train from Kuala Lumpur and I am currently on the return train now. It's a seven-hour adventure that includes many stops, and reversing to allow oncoming trains to pass, as well as on-and-offs to visit customs and immigration. If you like squatters in the men's room, you'll love how these ones openly drain onto the rail tracks! Be sure to bring your own food and water, and gaze out the window occasionally to see the towns and plantations fight for their spots in the jungle bush.<br /><br />I spent 100 Singapura dollars in two nights and two days - my 100 Australian-dollar traveller's cheque bought me 117 Singapura dollars. If you stay at Betelbox Backpackers, Tony will ensure you are informed of where to eat and what to see - for under $20 per night. Breakfasts were roti with fried egg and curry, at the intersection of Crane and Onan streets. Lunches were wherever-you-get-sucked-in in Chinatown, which is a taxi ride of under $10 each way. My first dinner included chilli-soaked green beans and stingray, frog in rice porridge, and satay chicken, lamb, and beef. This all at a food market near the hostel; split between four people, I spent about $10. The next dinner was classic - a curry house in a long line of restaurants along the boat quay on the Singapore River. Four of us split a bill of $125, and I recommend you do this for at least one night. The river has been cleaned up - it's not full of merchant boats and pollution as it appears in 30 year-old photographs - but there are still bumboats touring from quay to quay, and the city lights and atmosphere are attractive. The food I ate during my time in Singapore was delicious - although I focused on Indian, there are many asian flavours available!<br /><br />While you are in this area of the Singapore River, I suggest that you pay the $8 admission fee to the Asian Civilizations Museum, especially if you are intrigued by variations across the east, southeast, south, and west asias, and their Buddhist, Hindi, and Muslim histories. The museum is well-maintained and impressive, and so overwhelming that you may want to make multiple visits. I would have liked another visit!<br /><br />Singapore struck me as a modern, western city - you can see a lot colonial footprints everywhere.  After only a couple days, I would jump to conclude that Singapore is a comfy place where you can shop, eat, and have fun!  I might consider flying with Singapore Air in the future, for this reason.<br /><br />I now have three Malaysian visas stamped in my passport (plus two departure stamps), yet I've seen next-to-none of the country. Only six hours to pass before I can start experiencing Kuala Lumpur! There is Thai food in Kuala Lumpur, yes... however I hear Malay cuisine is incredible, plus I look forward to more Indian!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 10:19 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Wednesday, December 28, 2005
		</h3>






		<h4 className="blogitemtitle">
		I'll be back, no worries!
		</h4>





			<div className="blogitembody">
			So I am on Malaysian Air flight 148, halfway between Melbourne and Kuala Lumpur! According to the cool video monitor in front of me, we are flying at 928 km/h at an altitude of 39002 feet. It is -18ºC outside the aircraft! I wonder if my poor guitar is cold in the cargo of this jet?<br /><br />So, to answer a few questions... Why am I leaving Australia? Honestly, because I have a craving for Thai food! I'm going to Singapore with my brother and sister-in-law, first. Will I return to Australia? Are you kidding - I am crazy to leave! Of course I will return, maybe very soon, maybe a bit later! When am I returning to Canada? I dunno - stop asking so many questions! I slept three hours last night on a corridor floor in an international airport. I'd love to sleep now, but an Arabic musical film, "Kimo Wa Antimo," had me captivated, and now I'm listening to "The Best of Blue Note," volume whatever. All is well!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 4:31 PM &nbsp;
			</div>






		<h3 className="blogdate">
		Monday, December 26, 2005
		</h3>






		<h4 className="blogitemtitle">
		Coastal Christmas
		</h4>





			<div className="blogitembody">
			I am experiencing Christmas on the Sunshine Coast of Australia! During the late hours, when Christmas Eve became Christmas Day, I was swimming and body-surfing at Mooloolaba's main beach. It was a refreshing necessity after a hot afternoon of preparing turkey dinner, and a hot evening of stuffing myself with savories and sweets (and a few bottles of my friend, Cooper's Pale Ale). I write now from one of the few shady spots on the beach, escaping the nuclear sun on this cloudless, blue-sky scorcher. My cousin, a Mooloolaba local, predicts a thundershower this afternoon! So this is Christmas Day in coastal Australia... beach, beer, and barbeque!<br /><br />Between Rockhampton and now, I have been to a couple places worth mentioning. For three nights I stayed at The Arts Factory in Byron Bay. This place was so busy that tents were almost on top of each other! It had the vibe of a summer camp - everyone played guitar, didg, or percussion, and songs could be heard from all directions, all day. Cones and spliffs were constantly being lit: skunky smoke battled with fresh rainforest air. Water dragons and bush turkeys were mysteriously stoned as they roamed the premises. I spent most of my time enjoying the awesome swell at the beach! I will remember the great show at Buddha Bar, one Wednesday night: the didg and guitar songs of Cockatoo Paul, and the spectacular fire breathing, twirling, and juggling of crazy Steve-o (and friends, including Will Flangan from Dublin).<br /><br />I also spent two days and a night at Noosa, chilling with some new people, and reuniting with my Irish friend, Cormac! We spent most of our time in the water, swimming and trying to surf (not enough swell), at Tea Tree Bay and Sunshine Beach. Noosa is beautiful, with lots of natural parkland and coast line. I didn't see enough of it, and I've been told that it is known to reach very high tourist levels... but I had a blast there! So very good to see you again, Cormac!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:59 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Friday, December 02, 2005
		</h3>






		<h4 className="blogitemtitle">
		Australian Aluminum Quirk
		</h4>





			<div className="blogitembody">
			Australians say "aluminium," whereas (unless I've been away too long and am losing my point-of-reference) Canadians say "aluminum." Being Canadian, I have had silly debates with Australians over which spelling is correct. Probably both are - in Coles supermakets you will find "aluminium foil" stocked on the shelves. Today I purchased a dictionary for $1 from a Lifeline store:<br /><br />The Pocket Macquarie Dictionary. Second Edition, 1989. Jacaranda Wiley LTD, QLD, Australia. Reprinted 1997. ISBN 0 7016 2582 1.<br /><br />This is an Australian dictionary and, as expected, there is an entry for "aluminium" and no entry for, or reference to, "aluminum." However, there is a periodic table on page 1207, and element number 13 is "aluminum!" Yet this dictionary's entry/definition for "aluminium" includes:<br /><br />"Symbol: Al; at. wt: 26.9815; at. no: 13."<br /><br />I might find this more amusing than you do! But it's all cool, see this link: <a href="http://www.world-aluminium.org/history/language.html" target="new">http://www.world-aluminium.org/history/language.html</a>. Ask me sometime about shopping carts in Australia...
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 1:13 PM &nbsp;
			</div>









		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
